export default __webpack_public_path__ + "static/media/check_box.14aa244f.svg";